<script setup lang="ts">
defineProps<{
    companyPub: any
}>()

const { state } = useAppStore()
</script>

<template>
    <section
        v-if="companyPub && companyPub.product_lines"
        class="py-32 bg-chsc-raw-light border-b border-chsc-indigo-500"
    >
        <UContainer class="text-center">
            <header class="mb-6">
                <h2 class="text-chsc-indigo-500 fs-4xl font-eb-garamond font-medium">
                    {{ useText(state.strings, 'company_volume_range') }}
                </h2>
            </header>
            <p class="fs-5xl border-b boder-text inline-flex">
                {{ companyPub.volume }}
            </p>
        </UContainer>
    </section>
</template>
